module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Error adding referred","prependMessage":"Referred","appendMessage":"doesn\u0027t exist.","btnCancel":"Cancel"},"es":{"title":"Error al agregar referido","prependMessage":"El referido","appendMessage":"no existe.","btnCancel":"Cancelar"}}')
  delete Component.options._Ctor
}
